import { Route, Routes } from 'react-router'
import RootLayout from './components/RootLayout'
import Details from './pages/Details'
import Home from './pages/Home'
import NotFound from './pages/NotFound'

// Paths are exactly the ones the Next.js `pages/` tree served, so bookmarked and
// emailed links keep resolving:
//
//   pages/index.tsx    -> /
//   pages/details.tsx  -> /details?facilityId=<id>&facilityName=<name>
//
// `details` took its facility from the query string rather than a path segment,
// and still does.
const App = () => (
  <Routes>
    <Route element={<RootLayout />}>
      <Route index element={<Home />} />
      <Route path="details" element={<Details />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
)

export default App
